import LiveDataCards from './LiveDataCards';

export default LiveDataCards;
